import React from 'react';

export const Skeleton = ({ className = '' }) => (
  <div className={`animate-pulse rounded-lg bg-gray-200 dark:bg-dark-600 ${className}`} />
);

export const PageHeaderSkeleton = () => (
  <div className="card p-3.5 sm:p-6">
    <div className="flex items-center gap-2.5 sm:gap-4">
      <Skeleton className="h-11 w-11 sm:h-14 sm:w-14 rounded-xl sm:rounded-2xl shrink-0" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-5 w-40 sm:h-7 sm:w-56" />
        <Skeleton className="h-3 w-56 sm:h-4 sm:w-72" />
      </div>
    </div>
  </div>
);

export const TableSkeleton = ({ rows = 5, columns = 4 }) => (
  <div className="card overflow-hidden">
    <div className="border-b border-gray-100 dark:border-dark-700 px-6 py-4">
      <div className="flex gap-4">
        {Array.from({ length: columns }).map((_, index) => (
          <Skeleton key={index} className="h-4 flex-1" />
        ))}
      </div>
    </div>
    <div className="divide-y divide-gray-100 dark:divide-dark-700">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="flex items-center gap-4 px-6 py-4">
          {Array.from({ length: columns }).map((__, colIndex) => (
            <Skeleton key={colIndex} className={`h-4 ${colIndex === 0 ? 'w-1/3' : 'flex-1'}`} />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const CardGridSkeleton = ({ count = 4, columns = 'grid-cols-1 md:grid-cols-2' }) => (
  <div className={`grid ${columns} gap-4`}>
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className="card p-4">
        <Skeleton className="mb-3 h-32 w-full rounded-xl" />
        <Skeleton className="mb-2 h-5 w-3/4" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="mt-2 h-4 w-2/3" />
      </div>
    ))}
  </div>
);

export const FullPageSkeleton = ({ message = 'Loading...' }) => (
  <div className="space-y-6">
    <PageHeaderSkeleton />
    <TableSkeleton />
    <p className="sr-only">{message}</p>
  </div>
);

export const StepCardsSkeleton = ({ count = 4 }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className="card min-h-[160px] p-5">
        <div className="mb-3 flex items-center justify-between">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-6 w-24 rounded" />
        </div>
        <Skeleton className="mb-4 h-5 w-full" />
        <Skeleton className="h-4 w-2/3" />
      </div>
    ))}
  </div>
);
